import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=5fbc7c2a&scoped=true"
import script from "./ActionButtons.ts?vue&type=script&lang=ts&external"
export * from "./ActionButtons.ts?vue&type=script&lang=ts&external"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=5fbc7c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc7c2a",
  null
  
)

export default component.exports